<template>
  <div>
    <k-tabs>
      <k-tab to="/developer/broadcaster/release" label="Releases"></k-tab>
      <k-tab to="/developer/broadcaster/partial-release" label="Partial Releases"></k-tab>
      <k-tab to="/developer/broadcaster/init" label="Init"></k-tab>
      <k-tab to="/developer/broadcaster/test" label="Test"></k-tab>
      <k-tab to="/developer/broadcaster/tested" label="Tested"></k-tab>
      <k-tab to="/developer/broadcaster/released" label="Released"></k-tab>
      <k-tab to="/developer/broadcaster/rejected" label="Rejected"></k-tab>
      <k-tab to="/developer/broadcaster/archived" label="Archived"></k-tab>
    </k-tabs>
    <div v-if="is_settings">
      <k-layout v-for="release in filtered_releases" :key="release.id" row @click.stop="open_release(release)" class="elevation mb-1" style="border-bottom: 1px solid var(--ks-col-secondary); cursor: pointer; font-size: var(--ks-font-size-s);">
        <k-flex c1>
          {{release.id}}
        </k-flex>
        <k-flex c3>
          {{release.version}}
        </k-flex>
<!--        <k-flex c4>
          {{release.key}}
        </k-flex>-->
        <k-flex c2>
          {{release.updated_at}}
        </k-flex>
        <k-flex c3 style="overflow: hidden; text-overflow: ellipsis;">
          <k-chip v-for="os in release.os_version" :key="os" size="xs">
            {{os}}
          </k-chip>
        </k-flex>
        <k-flex c3 style="overflow: hidden; text-overflow: ellipsis;">
          <k-chip v-for="unit in release.unit_ids" :key="unit" size="xs">
            {{unit}}
          </k-chip>
        </k-flex>
      </k-layout>    
    </div>
  <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import ContentData from '../content/Data'
import SettingsModel from '@/models/settings.js';
import Vue from 'vue';
import BottomSheet from '../BottomSheet';

export default {
  props: ["type"],
  components: {
    ContentData,
    BottomSheet
  },
  data () {
    return {
      releases: []
    }
  },
  watch: {
    "$route" (newVal) {
      this.update_release_data();
    }
  },
  methods:{
    update_release_data () {
      var url = "content_list/" + this.list_id;
      var self = this;
      Vue.http.get(url).then((response) => {
        self.releases = response.body;
      }, (response) => {
      });
    },
    open_release(release) {
      this.$router.push("/developer/broadcaster/"+this.type+"/edit/" + this.list_id + "/data/" + release.id);
    }
  },
  computed: {
    filtered_releases() {
      var t = this.type || "release";
      var rels =  _.filter(this.releases, function(release) {
        if (release.status == t) return true;
        return false;
      });

      return _.orderBy(_.map(rels, function(release) {
        release.os_version = release.os_version ? release.os_version.split(",") : [];
        release.unit_ids = release.unit_ids ? release.unit_ids.split(",") : [];
        return release;
      }), ["id"], ["desc"]);

/*      return _.sortBy(rels, function(rel) {
        return rel.id;
      });*/
    },
    is_settings() {
      if (this.settings.length > 0) {
        this.update_release_data();
        return true;
      }
      return false;
    },
    settings () {
      return SettingsModel.list("developer_config");
    },
    list_id() {
      return this.settings[0].value.broadcaster_list_id;
    }
  }
}
</script>